let locizeVersion = `production`;

if(process.env.DEV) {
  locizeVersion = `latest`;
}

export default {
  locize: {
    namespace: {
      list: `cookie-notice-list`,
      ufe: `cookie-notice-ufe`,
    },
    projectId: `921c72df-62e9-4f61-8cb8-88e466b4bff4`,
    translationThreshold: 0.00001,
    version: locizeVersion,
  },
  version: {
    hash: {
      salt: `6`,
    },
  },
};
